module.exports = __webpack_public_path__ + "img/scene4.f5253d43.webp";